module.exports = __webpack_public_path__ + "img/7_205.d416a090.png";